import { read } from "./read"
import { write } from "./write"

export const project = {
  read,
  write,
}
